export default () => [
  {
    name: 'checkAccount',
    placeholder: 'APP外页面唤起APP时，检查账号一致',
    text: '检查账号一致',
    type: 'select',
    defaultValue: 'no',
    options: [
      { text: '不检查', value: 'no' },
      { text: 'H5转APP时校验', value: 'app' },
    ],
  },
  {
    type: 'fieldset',
    name: 'checkAccountConfig',
    labelWidth: '80px',
    text: '检查账号相关配置',
    display: (vm, { model }) => model.checkAccount === 'app',
    items: [{
      name: 'scene',
      text: '场景',
      defaultValue: '活动参与账号',
    }, {
      name: 'btnText',
      text: '按钮文案',
      defaultValue: '切换到活动账号',
    }, {
      name: 'hint',
      text: '提示文字',
      defaultValue: '检测到您原先活动参与的账号是{{userType}}账号，是否切换至该账号？',
    }],
  },
  {
    name: 'useRedirectPage',
    labelWidth: '180px',
    text: '强制打开app拉起通用页',
    type: 'switch',
    defaultValue: false,
  },
  {
    name: 'redirectPage',
    text: '中间页地址',
    display: (vm, { model }) => model.useRedirectPage,
    placeholder: '可使用${encodedSchemeUrl}占位符',
    defaultValue: 'https://film.qq.com/h5/app/openapp.html?schema=${encodedSchemeUrl}&auto=1',
  },
];
